import React from 'react';
import { Box } from '@material-ui/core';
import ByQuestionModuleTypeChart from 'components/ReportsModule/components/KeyboardingReport/Classroom/charts/ByQuestionModuleTypeChart';
import { useTranslation } from 'react-i18next';
import { KeyClassroomEngagementReportResult } from 'types/schema-generated-types';
import { buildSingleClassroomModuleData } from 'components/ReportsModule/components/KeyboardingReport/keyboarding-report-util';
import { AssessmentSubmodulesNames } from 'components/ReportsModule/types';

type Props = {
  reportData?: KeyClassroomEngagementReportResult;
  selectedModule: string;
};

const SingleModuleClassroomChart = ({ reportData, selectedModule }: Props) => {
  const { t } = useTranslation('Reports');
  const singleModuleData = buildSingleClassroomModuleData(reportData!, selectedModule!);
  const averageTimeSpent: any = singleModuleData?.data?.map(s =>
    !s.timeToAnswer ? 0 : s.timeToAnswer
  );
  const avgNoOfTries: any = singleModuleData?.data?.map(s =>
    !s.avgNoOfTries ? 0 : s.avgNoOfTries
  );
  const labels: any = singleModuleData?.data?.map(s => s.questionType);
  const colorMap: any = {
    [AssessmentSubmodulesNames.MODULE_1_MATH]: '#338AC6',
    [AssessmentSubmodulesNames.MODULE_2_MATH_ELA]: '#F6B247',
    [AssessmentSubmodulesNames.MODULE_3_ELA]: '#84DCC6'
  };
  return (
    <>
      <Box marginBottom={4}>
        <ByQuestionModuleTypeChart
          title="By Question Type - Average Time Spent per Question"
          helpText={t('averageTimeToCompleteQuestionHelp', { ns: 'ReportsHelpCards' })}
          yAxisText={t('Avg. Time Spent per Question (seconds)')}
          labels={labels}
          series={[{ name: 'seconds', data: averageTimeSpent }]}
          colors={[colorMap[selectedModule]]}
        />
      </Box>
      <Box>
        <ByQuestionModuleTypeChart
          title="By Question Type - Average Number of Tries"
          helpText={t('averageNumberOfTriesQuestionHelp', { ns: 'ReportsHelpCards' })}
          yAxisText={t('Avg. No. of Tries')}
          labels={labels}
          series={[{ name: 'tries', data: avgNoOfTries }]}
          colors={[colorMap[selectedModule]]}
        />
      </Box>

      {/* <DownloadListCard
        onClick={openConstructAResponse}
        title="View Question Results"
        Icon={GetAppIcon}
        data={downloadData as any}
        xs={12}
      /> */}
    </>
  );
};

export default SingleModuleClassroomChart;
